<div class="recommendation-item layout-row layout-align-start-start p-3"
     [ngClass]="'direction-' + direction">
  <div class="severity-indicator">
    <bringoz-icon fill="{{
    recommendation.severity === RecommendationSeverity.High ? '#D52424'
    : recommendation.severity === RecommendationSeverity.Medium ? '#266AFF'
    : '#38A138'}}"
                  iconName="star-blue">
    </bringoz-icon>
  </div>

  <div class="recommendation-content flex layout-column">
    <div class="recommendation-title" *ngIf="recommendation?.insightOutput?.parameterizedTitleMessage">
      {{ parametersData ? (recommendation?.insightOutput?.parameterizedTitleMessage | parseParameters: parametersData) : recommendation?.insightOutput?.parameterizedTitleMessage }}
    </div>
    <div class="recommendation-description">
      {{ parametersData ? (recommendation?.insightOutput?.parameterizedMessage | parseParameters: parametersData) : recommendation?.insightOutput?.parameterizedMessage }}
    </div>
    <div *ngIf="routeIds" class="recommendation-routes" (click)="onClickOnRoutes(routeIds)">
      <span class="routes-label" translate>Routes:</span>
      <span class="routes-values">{{ routeIds }}</span>
    </div>
    <div class="bottom-row layout-row layout-align-start-center">
      <div class="flex layout-row layout-align-end-center">
        <span class="recommendation-created-at">{{ recommendation.createdAt | date: 'medium' }}</span>
      </div>
    </div>

    <div class="bottom-row layout-row layout-align-start-center">
      <div class="flex left-actions layout-row layout-align-start-center">
        <button *ngIf="recommendation.canApply"
                class="md-accent md-raised md-button md-bringoz-main-theme margin-0"
                type="button"
                appBringozIdGenerator="recommendation_applied"
                (click)="onApplyRecommendation()">
          <span translate>Apply</span>
        </button>
        <span *ngIf="showRecommendationLink" appBringozIdGenerator="recommendation_action_clicked" (click)="onGoToRecommendation()" class="recommendation-link" translate>Go to recommendation</span>
      </div>

      <div class="flex action-icons layout-row layout-align-end-center">
        <a appBringozIdGenerator="recommendation_marked_read" (click)="markRecommendationToRead()">
          <span class="mark-recommendation" translate>Mark as read</span>
        </a>
        <bringoz-button type="tertiary"
                        appBringozIdGenerator="recommendation_feedback_given_negative"
                        (onClick)="updateRecommendationFeedback(RecommendationFeedback.NEGATIVE)"
                        size="fit">
          <bringoz-icon [fill]="recommendation?.feedback === RecommendationFeedback.NEGATIVE ? 'crimson' : '#7E7E7E'" iconName="bad"></bringoz-icon>
        </bringoz-button>
        <bringoz-button type="tertiary"
                        appBringozIdGenerator="recommendation_feedback_given_positive"
                        (onClick)="updateRecommendationFeedback(RecommendationFeedback.POSITIVE)"
                        size="fit">
          <bringoz-icon [fill]="recommendation?.feedback === RecommendationFeedback.POSITIVE ? 'limegreen' : '#7E7E7E'" iconName="good"></bringoz-icon>
        </bringoz-button>
      </div>
    </div>
  </div>
</div>
